<app-logo-header></app-logo-header>
<div id="otpDiv" class="otpPage"></div>
<form #form [action]="actionUrl" [method]="method"></form>
